import get from '../../common/helpers/get'

export function check(id: string) {
  const radioElement = document.getElementById(id) as HTMLInputElement

  if (radioElement) {
    radioElement.checked = true
  }
}

export function getPanelRadioID(id: number | string) {
  return `rg-wizard-step-radio-${id}`
}

function getWidth(element: HTMLElement) {
  if (!element) {
    return 0
  }

  const { width } = element.getBoundingClientRect() || {}
  return width || 0
}

function getHalfWidth(element: HTMLElement) {
  return getWidth(element) / 2
}

function getCenterPosition(element: HTMLElement) {
  if (!element) {
    return 0
  }

  const { left = 0, width = 0 } = element.getBoundingClientRect() || {}
  return left + width / 2
}

function getFirstStep(stepsContainerElement: HTMLElement) {
  return stepsContainerElement.querySelector('li:first-child') as HTMLElement
}

function getLastStep(stepsContainerElement: HTMLElement) {
  return stepsContainerElement.querySelector('li:last-child') as HTMLElement
}

function getLastCompletedStep(stepsContainerElement: HTMLElement) {
  const array = stepsContainerElement.querySelectorAll('li.is-complete')

  return get(array, array.length - 1) as HTMLElement
}

export function getLinesContainerPadding(stepsContainerElement: HTMLElement) {
  if (!stepsContainerElement) {
    return { paddingLeft: '0px', paddingRight: '0px' }
  }

  const firstStepElement = getFirstStep(stepsContainerElement)
  const lastStepElement = getLastStep(stepsContainerElement)

  if (!firstStepElement || !lastStepElement) {
    return { paddingLeft: '0px', paddingRight: '0px' }
  }

  return {
    paddingLeft: `${getHalfWidth(firstStepElement)}px`,
    paddingRight: `${getHalfWidth(lastStepElement)}px`,
  }
}

export function getGreenLineWidth(
  stepsContainerElement: HTMLElement,
  linesContainerElement: HTMLElement
) {
  if (!stepsContainerElement || !linesContainerElement) {
    return '0px'
  }

  const firstStepElement = getFirstStep(stepsContainerElement)
  const lastStepElement = getLastStep(stepsContainerElement)
  const currStepElement = stepsContainerElement.querySelector('li.is-current') as HTMLElement
  const lastCompleteStepElement = getLastCompletedStep(stepsContainerElement) as HTMLElement

  if (!linesContainerElement || !firstStepElement || !lastStepElement) {
    return '0px'
  }

  const { paddingLeft, paddingRight } = getLinesContainerPadding(stepsContainerElement)

  const containerWidth =
    getWidth(linesContainerElement) -
    parseInt(String(paddingLeft), 10) -
    parseInt(String(paddingRight), 10)

  const distanceFromCurrentToFirst =
    Math.max(getCenterPosition(currStepElement), getCenterPosition(lastCompleteStepElement)) -
    getCenterPosition(firstStepElement)

  return `${(distanceFromCurrentToFirst / containerWidth) * 100}%`
}
